import { HStack, Img, Stack, Text } from '@chakra-ui/react';
import { Link } from 'react-router-dom';

import { v4 } from 'uuid';
import { PROTECTED_PATHS } from '../../../app/constants';
import { dynamicPathhandler } from '../../../components/utils/dynamicPathHandler';

export const ActiveProducts = ({ data }) => {
  const { VIEW_ONE_SHOP_PRODUCT } = PROTECTED_PATHS;
  const path = dynamicPathhandler(VIEW_ONE_SHOP_PRODUCT);

  return (
    <Stack spacing='5'>
      {data?.map((data) => (
        <Link key={v4()} to={`${path}/${data._id}`}>
          <HStack gap='1rem' bg='gray.50' shadow='sm' p='1'>
            <Img w='75px' h='75px' src={data?.imageUrl[0]} alt='product' />
            <Stack>
              <Text fontSize='1rem'>{data?.itemName}</Text>
              <Text fontSize='1.1rem' fontWeight={600}>
                {data?.price} NGN
              </Text>
            </Stack>
          </HStack>
        </Link>
      ))}
    </Stack>
  );
};
